import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/home' },
  {
    path: 'auth',    
    loadChildren: () => import('./auth/auth.module').then( m => m.AuthModule)
  },
  { 
    path: 'home', 
    loadChildren: () => import('./home/home.module').then( m => m.HomeModule)
  },
  {
    path: 'settings',    
    loadChildren: () => import('./settings/settings.module').then( m => m.SettingsModule)
  },
  {
    path: 'user-management',    
    loadChildren: () => import('./user-management/user-management.module').then( m => m.UserManagementModule)
  },
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],

})
export class AppRoutingModule { }
